import React from 'react';
import PropTypes from 'prop-types';

const CheckboxButton = ({ text = '', name = '', onChange, value = '', checked, blockElement = false, classNames = '', leftAlign, rounded = false }) => {
  const styles = rounded ? { padding: '8px 16px' } : { padding: '16px' };
  if (blockElement) styles.display = 'block';
  if (leftAlign) styles.textAlign = 'left';
  return (
    <div className={`checkbox-btn ${classNames}`}>
      <label onChange={onChange} title="" style={blockElement ? { display: 'block', marginBottom: 0 } : {}}>
        <input type="checkbox" checked={checked} value={value} name={name} />
        <span style={styles} className={`btn text-wrap${rounded ? ' btn-rounded' : ''}`}>{text}</span>
      </label>
    </div>
  );
};

CheckboxButton.propTypes = {
  onClick: PropTypes.func,
  text: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  checked: PropTypes.bool,
  classNames: PropTypes.string,
  blockElement: PropTypes.bool,
  rounded: PropTypes.bool,
  leftAlign: PropTypes.bool
};

export default CheckboxButton;
